var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuballamaLogoSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.5 283.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 160.7,
    width: 25,
    height: 43.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 258.3,
    y: 160.7,
    width: 25,
    height: 43.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.5,177.6c-2.5,13.7-14.6,24.1-28.9,24.1s-26.4-10.4-28.9-24.1h-14.6c2.7,21.7,21.1,38.5,43.5,38.5s40.9-16.8,43.5-38.5h-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.9,164.4c8,0,14.5-6.5,14.5-14.5s-6.5-14.5-14.5-14.5-14.5,6.5-14.5,14.5c0,8,6.5,14.5,14.5,14.5ZM169.3,164.4c8,0,14.5-6.5,14.5-14.5s-6.5-14.5-14.5-14.5-14.4,6.5-14.4,14.5c0,8,6.4,14.5,14.4,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.6,104.8c35.8,0,64.9,29.1,64.9,64.9s-29.1,64.9-64.9,64.9-64.9-29.1-64.9-64.9c0-35.8,29.1-64.9,64.9-64.9M141.6,82.8c-47.9,0-86.8,38.9-86.8,86.8s39,86.8,86.8,86.8,86.8-39,86.8-86.8c0-47.8-38.9-86.8-86.8-86.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.4,136.5c-15-62.8-71.5-109.6-138.8-109.6S17.8,73.7,2.8,136.5h24.9c14.4-49.3,60-85.4,113.9-85.4s99.5,36.1,113.9,85.4h24.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuballamaLogoSymbolWhite);
export default __webpack_public_path__ + "static/media/cuballama-logo-symbol-white.0795b7723caa37b3e818afb29322f5c9.svg";
export { ForwardRef as ReactComponent };